import { Tooltip } from 'antd'
import React from 'react'

export default function ComingSoonTooltip({placement = "top", children, ...props}) {
    return (
        <Tooltip title="Coming soon!" placement={placement} {...props}>
            {children}
        </Tooltip>
    )
}